import React from 'react'
import DbSection from './db-section'

export default ({ children }) => {
  return (children || []).map(section => <DbSection {...section} key={`dbsection_${section.title}`} />)
}
